export const manifest = {
  screens: {
    scr_konfdd: { name: "Home", route: "/" },
  },
}
